export default __webpack_public_path__ + "media/attila.e6d5bda4.jpg";